import { __awaiter } from "tslib";
import React from 'react';
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { dispatch } from '@@/store';
import { showInfo } from '@/components';
import { showCarDetail, fontEndConfig } from '@/shared/utils';
import { notification, Modal } from 'antd';
import { judgeObj, judgeArr, dealValueShow, thousandBitSeparator } from '@/shared/functions';
import AuthorizedNot from '@/components/Auth/authNot';
import styles from '@/style/color.less';
import { dealSourceType } from '@/pages/Finance/PayManage/_components/functions';
import Purchase from '@/pages/Finance/PayManage/_components/Purchase';
/**
 *  @desc 操作列
 */
const _opt = {
    title: '操作',
    dataIndex: 'option',
};
/**
 *  @desc 操作列 待审批dom
 */
const _noApproval = (record) => {
    const { orderStatus, lockType } = record;
    // 有操作：交付中订单无争议；交易成功无争议；其他无操作
    const canOpt = lockType === 0 && (orderStatus === 35 || orderStatus === 80);
    if (canOpt) {
        return (<>
        
        <AuthorizedNot allow={'psgjb-mjjs-enter'}>
          <a href="javascript:;" onClick={() => dispatch.paySeller.confirmPay({ record, pay_confirm_type: 'part_pass' })}>
            通过并打款
          </a>
          <a luban-id={'PSGJB-FIANCE-FKGL-MJDK-BH'} href="javascript:;" onClick={() => dispatch.paySeller.userConfirmReject(record)}>
            驳回
          </a>
        </AuthorizedNot>
        
        <AuthorizedNot allow={'psgjb-finansepayment-select'} notAllow={'psgjb-mjjs-enter'}>
          <a href="javascript:;" onClick={() => dispatch.paySeller.confirmPay({ record, pay_confirm_type: 'pass' })}>
            通过并打款
          </a>
          <a luban-id={'PSGJB-FIANCE-FKGL-MJDK-BH'} href="javascript:;" onClick={() => dispatch.paySeller.userConfirmReject(record)}>
            驳回
          </a>
        </AuthorizedNot>
      </>);
    }
    return fontEndConfig.noValueReplace;
};
/**
 *  @desc 操作列 已通过dom
 */
const _pass = (record) => {
    const { orderStatus, lockType } = record;
    // 部分付款 交付中订单无争议，交易成功无争议 - 查看|通过并打款；其他 查看
    // 全部付款 查看
    const canOpt = record.isPayPart && lockType === 0 && (orderStatus === 35 || orderStatus === 80);
    return (<>
      {
    // 是否是部分付款
    canOpt &&
        <AuthorizedNot allow={'psgjb-mjjs-enter'}>
          <a href="javascript:;" onClick={() => dispatch.paySeller.confirmPay({ record, pay_confirm_type: 'part_pass' })}>
            通过并打款
          </a>
        </AuthorizedNot>}
      <a href="javascript:;" onClick={() => showInfo('remit', record.orderId)}>
        查看
      </a>
    </>);
};
/**
 *  @desc 接口公共数据
 */
const _common = (data) => {
    const { i, pageCurrent, v } = data;
    const _add = { disabled: false };
    // _add.disabled: 是否可以多选 以下为禁选情况
    // 待审批--交付中订单争议；交易失败；
    // 已通过--全部付款完成；部分付款交付中订单争议；交易失败；
    // 已驳回--全部；
    _add.disabled = false;
    switch (v.payApprovalStatus) {
        case 1: // 待审批 申请时间---更新时间
            _add.userDefine_updateTime = dealValueShow(v.orderPayCreateTime);
            _add.optType = 'noApproval';
            switch (v.orderStatus) {
                case 35: // 交付中 lockType:0 正常非争议
                    v.lockType !== 0 ? _add.disabled = true : '';
                    break;
                case 100: // 交易失败
                    _add.disabled = true;
                    break;
            }
            break;
        case 2: // 已通过 通过时间---更新时间
            _add.userDefine_updateTime = dealValueShow(v.payOverTime);
            _add.optType = 'pass';
            if (v.payStatus === 2 || v.payStatus === 3) {
                _add.disabled = true;
            }
            else {
                switch (v.orderStatus) {
                    case 35: // 交付中 lockType:0 正常非争议
                        v.lockType !== 0 ? _add.disabled = true : '';
                        break;
                    case 100: // 交易失败
                        _add.disabled = true;
                        break;
                }
            }
            break;
        case 3: // 已驳回 驳回时间---更新时间
            _add.userDefine_updateTime = dealValueShow(v.payOverTime);
            _add.optType = 'reject';
            _add.disabled = true;
            break;
    }
    switch (v.orderStatus) {
        case 35:
            _add.orderStatusDesc = '交付中';
            break;
        case 80:
            _add.orderStatusDesc = '交易成功';
            break;
        case 100:
            _add.orderStatusDesc = '交易失败';
            break;
        default:
            _add.orderStatusDesc = fontEndConfig.noValueReplace;
    }
    return Object.assign({ key: v.orderId, number: pageCurrent * 20 - 19 + i, orderId: dealValueShow(v.orderId), carType: dealValueShow(v.goodsName), address: dealValueShow(v.carLocation), seller: dealValueShow(v.sellerName), sellerCode: dealValueShow(v.sellerCode), carNum: dealValueShow(v.carLicense), buyer: dealValueShow(v.buyerName), buyerCode: dealValueShow(v.buyerCode), dealPrice: dealValueShow(thousandBitSeparator(v.sellerPriceYuanUnit)), servicePrice: dealValueShow(thousandBitSeparator(v.commissionYuanUnit)), commission: dealValueShow(thousandBitSeparator(v.brokerageYuanUnit)), handPrice: dealValueShow(thousandBitSeparator(v.totalPriceYuanUnit)), applyPerson: dealValueShow(v.editedBy), goodsId: v.goodsId, carVin: dealValueShow(v.carVin), sellerPriceYuanUnit: v.sellerPriceYuanUnit, tenantCode: v.tenantCode, alreadyPayMoney: dealValueShow(thousandBitSeparator(v.payFrpriceYuanUnit)), isPayPart: v.payStatus === 2 || v.payStatus === 3 ? false : true, payApprovalStatus: v.payApprovalStatus, orderStatus: v.orderStatus, lockType: v.lockType, payStatus: v.payStatus, sourceType: v.sourceType }, _add);
};
const initState = {
    columns: [
        {
            title: '序列',
            dataIndex: 'number',
            width: 40,
        }, {
            title: '订单信息',
            width: 336,
            render: (text, record, index) => {
                const { orderId, goodsId, carType, carVin, carNum, address, sourceType } = record;
                return (<>
            订单号：{orderId}<br />
            <a href="javascript:;" onClick={() => {
                    goodsId && showCarDetail(goodsId);
                }}>
              {carType}
            </a><br />
            VIN码：{carVin}<br />
            <div className="flex__row-start" style={{ marginTop: '8px' }}>
              <div className={`${styles['uIDesign--dealType']}`} style={{ marginRight: '8px' }}>
                {dealSourceType(sourceType)}
              </div>
              <div className={`${styles.uIDesign_orange}`} style={{ marginRight: '8px' }}>
                {carNum}
              </div>
              <div className={`${styles.uIDesign_blue}`}>
                {address}
              </div>
            </div>
          </>);
            },
        }, {
            title: '买卖家信息',
            width: 171,
            render: (text, record, index) => {
                const { buyer, seller, buyerCode, sellerCode, orderId } = record;
                return (<>
            买家经销商：
              {buyerCode ?
                    <a href="javascript:;" onClick={() => showInfo('buyer', buyerCode)}>
                  {buyer}
                </a> : buyer}
            <br />
            卖家经销商：
              {sellerCode ?
                    <a href="javascript:;" onClick={() => showInfo('seller', sellerCode)}>
                  {seller}
                </a> : seller}
            <br />
            采购信息：
            <Purchase orderId={orderId}/>
          </>);
            },
        }, {
            title: '价格信息(元)',
            width: 145,
            render: (text, record, index) => {
                const { dealPrice, handPrice, commission, servicePrice } = record;
                return (<>
            成交价 {dealPrice}<br />
            合手价 {handPrice}<br />
            <div className={`${styles.uIDesign_orange}`} style={{ marginTop: '8px', display: 'inline-block' }}>
              佣金{commission}
            </div>
            <div className={`${styles.uIDesign_blue}`} style={{ marginTop: '8px', display: 'inline-block' }}>
              服务费{servicePrice}
            </div>
          </>);
            },
        }, {
            title: '已打款(元)',
            dataIndex: 'alreadyPayMoney',
            width: 103,
        }, {
            title: '申请人',
            dataIndex: 'applyPerson',
            width: 73,
        }, {
            title: '更新时间',
            width: 95,
            render: (text, record, index) => {
                const { userDefine_updateTime: time } = record;
                const _dealTime = time.split(' ');
                return (<>{_dealTime[0]}<br />{_dealTime[1]}</>);
            },
        }, {
            title: '状态',
            dataIndex: 'orderStatusDesc',
            width: 70,
        },
        Object.assign(Object.assign({}, _opt), { width: 93, render: (text, record, index) => {
                let context = fontEndConfig.noValueReplace;
                switch (record.optType) {
                    case 'noApproval':
                        context = _noApproval(record);
                        break;
                    case 'pass':
                        context = _pass(record);
                        break;
                }
                return (<div className={'table-operate-btn'} style={{ display: 'flex', alignContent: 'flex-start', flexWrap: 'wrap', flexShrink: 0 }}>
            {context}
          </div>);
            } })
    ],
    data: [],
    totalNum: 0,
    showPayConfirm: false,
    choosedOpt: 'noApproval',
    choosedOpt2: '-999',
    choosedOpt3: '-999',
    pageCurrent: 1,
    pageSize: 20,
    choosedOrderId: '',
    choosedHandPrice: 0,
    tableLoading: false,
    pay_confirm_type: 'pass',
    choosedParams: {},
    disabledSelect2: false,
    selectedRowKeys: [],
    selectedRows: [],
    payAmount: 0,
    payAmountY: 0,
    showBatchModal: false,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * @desc 加载列表
         */
        load(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { choosedOpt, choosedOpt2, choosedOpt3, pageCurrent, pageSize } = rootState.paySeller;
                const { topParams } = rootState.payTop;
                const _param = Object.assign({ pageCurrent,
                    pageSize, payStatus: choosedOpt2, orderStatus: choosedOpt3 }, topParams);
                this.SET_STATE({ tableLoading: true });
                let _r;
                switch (choosedOpt) {
                    case 'all':
                        _r = yield this.sellerAll(_param);
                        break;
                    case 'noApproval':
                        _r = yield this.sellerNoApproval(_param);
                        break;
                    case 'reject':
                        _r = yield this.sellerReject(_param);
                        break;
                    case 'pass':
                        _r = yield this.sellerPass(_param);
                        break;
                    default:
                        _r = { items: [], totalNum: 0 };
                        console.warn('卖家打款下拉类型错误');
                }
                this.SET_STATE({ tableLoading: false });
                this.SET_STATE({
                    data: _r.items,
                    totalNum: _r.totalNum,
                });
            });
        },
        /**
         * @desc 卖家全部接口
         */
        sellerAll(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = { totalNum: 0, items: [] };
                const { pageCurrent } = rootState.paySeller;
                return Api.order.getSellerPendingAllList(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data) || !judgeArr(data.items)) {
                        return result;
                    }
                    result.totalNum = data.totalNumber;
                    result.items = data.items.map((v, i) => {
                        const _item = Object.assign({}, _common({ i, v, pageCurrent }));
                        return _item;
                    });
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 卖家待审批接口
         */
        sellerNoApproval(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = { totalNum: 0, items: [] };
                const { pageCurrent } = rootState.paySeller;
                return Api.order.getOrderTBCViewList(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data) || !judgeArr(data.items)) {
                        return result;
                    }
                    result.totalNum = data.totalNumber;
                    result.items = data.items.map((v, i) => {
                        const _item = Object.assign({}, _common({ i, v, pageCurrent }));
                        return _item;
                    });
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 卖家已驳回接口
         */
        sellerReject(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = { totalNum: 0, items: [] };
                const { pageCurrent } = rootState.paySeller;
                return Api.order.getOrderTradeFailViewList(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data) || !judgeArr(data.items)) {
                        return result;
                    }
                    result.totalNum = data.totalNumber;
                    result.items = data.items.map((v, i) => {
                        const _item = Object.assign({}, _common({ i, v, pageCurrent }));
                        return _item;
                    });
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 卖家已通过接口
         */
        sellerPass(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = { totalNum: 0, items: [] };
                const { pageCurrent } = rootState.paySeller;
                return Api.order.getOrderSuccessView(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data) || !judgeArr(data.items)) {
                        return result;
                    }
                    result.totalNum = data.totalNumber;
                    result.items = data.items.map((v, i) => {
                        const _item = Object.assign({}, _common({ i, v, pageCurrent }));
                        return _item;
                    });
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 通过并打款
         */
        confirmPay(payload, { update, state, rootState }) {
            const { record, pay_confirm_type = 'pass' } = payload;
            const { orderId, sellerPriceYuanUnit, tenantCode } = record;
            switch (pay_confirm_type) {
                case 'pass':
                    if (orderId && sellerPriceYuanUnit) {
                        this.PAYCONFIRM_TYPE(pay_confirm_type);
                        this.SET_CHOOSE_ORDERID(orderId);
                        this.SET_CHOOSE_HANDPRICE(sellerPriceYuanUnit);
                        dispatch.payMoneyModal.getPayRadios({ type: 'pass' });
                        this.SHOW_PAYCONFIRM();
                    }
                    break;
                case 'part_pass':
                    if (orderId && tenantCode) {
                        this.PAYCONFIRM_TYPE(pay_confirm_type);
                        this.SET_CHOOSE_ORDERID(orderId);
                        this.SET_CHOOSE_PARAMS({ tenantCode });
                        dispatch.payMoneyModal.getPayRadios({ type: 'pass' });
                        dispatch.payMoneyModal.getPartPassPriceAndDesc({ orderId, params: { tenantCode } });
                        this.SHOW_PAYCONFIRM();
                    }
                    break;
            }
        },
        /**
         * @desc 搜索列表  更改第一个下拉选项
         */
        onChange(payload, { update, state, rootState }) {
            // 【卖家】更改下拉选项
            this.SET_CHOOSED_OPT(payload);
            // 处理联动
            switch (payload) {
                case 'all':
                case 'pass':
                    this.SET_STATE({ disabledSelect2: false });
                    break;
                default:
                    this.SET_STATE({ disabledSelect2: true, choosedOpt2: '-999' });
            }
        },
        /** 驳回 */
        toReject(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { orderId } = payload;
                if (orderId) {
                    yield Api.order.sellerPayReject({ orderId }).then((_r) => {
                        if (_r) {
                            notification.success({
                                message: '卖家打款审批已驳回',
                                description: '结果将返回申请运营人员！',
                            });
                            this.RESET_STATE();
                            this.load({});
                        }
                        else {
                            notification.error({
                                message: '卖家打款审批驳回失败',
                            });
                        }
                    });
                }
            });
        },
        /** 确认是否驳回 */
        userConfirmReject(payload, { update, state, rootState }) {
            Modal.confirm({
                title: '您确定要驳回吗?',
                onOk() {
                    dispatch.paySeller.toReject(payload);
                },
            });
        },
        /** 批量通过并打款金额 */
        batchPayMoney(payload, { update, state, rootState }) {
            const { selectedRowKeys } = state;
            // 处理传参
            const _param = {
                orderIds: JSON.stringify(selectedRowKeys),
            };
            return Api.order.sellerBatchMoney(_param).then((_r) => {
                const data = JSON.parse(JSON.stringify(_r));
                if (judgeObj(data)) {
                    const { payAmount, payAmountY } = data;
                    this.SET_STATE({
                        payAmount,
                        payAmountY,
                        showBatchModal: true,
                    });
                }
            }).catch((error) => {
                // 如果计算出现问题--如code: 20001:有争议|20002:有付款|20003:已关闭 则需要清空多选项 清空钱
                const clearCodeArr = ['20001', '20002', '20003'];
                if (judgeObj(error) && clearCodeArr.includes(error.code)) {
                    this.clearSelectedRowKeysPayCountCloseModal({});
                }
            });
        },
        clearSelectedRowKeysPayCountCloseModal() {
            return new Promise((resolve) => {
                this.CloseModal();
                setTimeout(() => {
                    this.Clear_selectedRowKeys_payCount();
                    resolve();
                }, 0);
            });
        },
        /** 批量通过并打款确认 */
        batchPayConfirm(payload, { update, state, rootState }) {
            // 处理传参
            const { selectedRowKeys, payAmount } = state;
            const _param = {
                orderIds: JSON.stringify(selectedRowKeys),
                amount: payAmount,
            };
            Api.order.sellerBatchConfirm(_param).then((_r) => {
                // 批量通过并打款确认成功 弹出成功提示 刷新数据
                if (!!_r) {
                    notification.success({
                        message: '操作成功！',
                    });
                    // 操作成功 需要清空多选项 清空钱
                    this.clearSelectedRowKeysPayCountCloseModal({}).then(() => {
                        this.load({});
                    });
                }
            }).catch((error) => {
                // 如果计算出现问题--如code: 20001:有争议|20002:有付款|20003:已关闭|20004:金额不对 则需要清空多选项 清空钱
                const clearCodeArr = ['20001', '20002', '20003', '20004'];
                if (judgeObj(error) && clearCodeArr.includes(error.code)) {
                    this.clearSelectedRowKeysPayCountCloseModal({});
                }
            });
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SHOW_PAYCONFIRM(state, payload) {
            state.showPayConfirm = true;
        },
        HIDE_PAYCONFIRM(state, payload) {
            state.showPayConfirm = false;
        },
        SET_CHOOSED_OPT(state, payload) {
            state.choosedOpt = payload;
        },
        SET_CHOOSED_OPT2(state, payload) {
            state.choosedOpt2 = payload;
        },
        SET_CHOOSED_OPT3(state, payload) {
            state.choosedOpt3 = payload;
        },
        SET_PAGE_CURRENT(state, payload) {
            state.pageCurrent = payload;
        },
        SET_CHOOSE_ORDERID(state, payload) {
            state.choosedOrderId = payload;
        },
        SET_CHOOSE_HANDPRICE(state, payload) {
            state.choosedHandPrice = payload;
        },
        PAYCONFIRM_TYPE(state, payload) {
            state.pay_confirm_type = payload;
        },
        SET_CHOOSE_PARAMS(state, payload) {
            state.choosedParams = payload;
        },
        Clear_selectedRowKeys_payCount(state) {
            state.selectedRowKeys = [];
            state.selectedRows = [];
            state.payAmount = 0;
        },
        CloseModal(state) {
            state.showBatchModal = false;
        },
    },
});
